import { render, staticRenderFns } from "./BfSelect.vue?vue&type=template&id=a45888cc&"
import script from "./BfSelect.vue?vue&type=script&lang=js&"
export * from "./BfSelect.vue?vue&type=script&lang=js&"
import style0 from "./BfSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports